// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__25KQ8","selected":"Chip_selected__1FcfB"};